import Modal from 'react-responsive-modal';

interface IIFrameModal {
  url: string;
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function IFrameModal({ url, modalIsOpen, toggleModal }: IIFrameModal) {
  return (
    <>
      {url && (
        <Modal
          open={modalIsOpen}
          onClose={toggleModal}
          center
          styles={{
            modal: {
              width: '80%', // Define a largura do modal para 80% da tela
              maxWidth: '80%', // Garante que o modal não ultrapasse 80% da largura da tela
              height: '80%', // Define a largura do modal para 80% da tela
              maxHeight: '80%',
            },
          }}
        >
          <div
            style={{
              position: 'relative',
              textAlign: 'center',
              height: '100%',
            }}
          >
            <iframe
              src={url}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            ></iframe>
          </div>
        </Modal>
      )}
    </>
  );
}
